(function () {
  let isInnerFixed = false
  var productSlider = document.querySelectorAll('.js_product_slider')

  for (var i = 0; i < productSlider.length; i++) {
    const slider = productSlider[i]
    const slides = slider.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length
    const paginationEl = slider.querySelector('.swiper-pagination')

    const swiper_product_slider = new Swiper(slider, {
      slidesPerView: 1,
      loop: slides > 1,
      centeredSlides: true,
      loopAdditionalSlides: 2,
      speed: 500,
      shortSwipes: 20,
      preventClicks: true,
      breakpoints: {
        768: {
          centeredSlides: true,
          slidesPerView: slides === 1 ? 1 : 2,
        },
        1200: {
          slidesPerView: slides === 1 ? 1 : 3,
        }
      },
      navigation: {
        nextEl: '.js_product_slider_nav .swiper-button-next',
        prevEl: '.js_product_slider_nav .swiper-button-prev',
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      on: {
        slideChangeTransitionEnd: function () {
          // Remove click events from all slides
          jQuery('.js_product_slider .product-slider__card-link').off('click')

          // Add click event only for current prev and next slide
          jQuery('.js_product_slider .swiper-slide-next .product-slider__card-link').on('click', function (e) {
            e.preventDefault()
            swiper_product_slider.slideNext()
          })

          jQuery('.js_product_slider .swiper-slide-prev .product-slider__card-link').on('click', function (e) {
            e.preventDefault()
            swiper_product_slider.slidePrev()
          })

          jQuery('.js_product_slider .swiper-slide-active a.product-slider__card-link').on('click', function (e) {
            // const productId = jQuery(this).data('product-id');
            const productTitle = jQuery(this).data('product-title');
            const linkUrl = jQuery(this).attr('href');

            const gtmEvent = {
              trigger: 'Product Slider',
              event_id: '1.3',
              event: 'select_content',
              link_url: linkUrl,
              event_campaign: 'general',
              content_type: 'product slider',
              content_id: productTitle,
              category: 'products',
              market: window.getMarketFromUrl()
            };

            dataLayer.push(gtmEvent);
          });
        }
      },
    })

    // Add GTM tracking for arrow navigation buttons
    const nextButton = document.querySelector('.js_product_slider_nav .swiper-button-next');
    const prevButton = document.querySelector('.js_product_slider_nav .swiper-button-prev');

    nextButton.addEventListener('click', function () {
      // GTM event data object
      const gtmEvent = {
        trigger: 'Product Slider NextArrow',
        event_id: '1.1',
        event: 'slider_navigation',
        event_campaign: 'general',
        content_type: 'product slider',
        category: 'products',
        market: window.getMarketFromUrl()
      };

      dataLayer.push(gtmEvent);
    });

    prevButton.addEventListener('click', function () {
      const gtmEvent = {
        trigger: 'Product Slider PrevArrow',
        event_id: '1.1',
        event: 'slider_navigation',
        event_campaign: 'general',
        content_type: 'product slider',
        category: 'products',
        market: window.getMarketFromUrl()
      };

      dataLayer.push(gtmEvent);
    });
  }
  function fixCardHeaderInnerEl () {

    setTimeout(function () {
      if (!isInnerFixed) {
        jQuery('.product-slider__card-header-inner').css({ 'height': '100.5%' })
        isInnerFixed = true
      }
      else {
        jQuery('.product-slider__card-header-inner').css({ 'height': '100%' })
        isInnerFixed = false
      }
    }, 100)
  }
  // fixCardHeaderInnerEl()
})()